import React, { useEffect, useState } from 'react'
import defaultProfile from '../../resources/images/default.png'
import {
  FaTachometerAlt, FaPaperPlane, FaExchangeAlt, FaDollarSign,
  FaMinusCircle, FaPlusCircle, FaTicketAlt, FaReceipt,
  FaMoneyBill, FaChevronDown, FaChevronUp,
} from 'react-icons/fa'
import { Link, useLocation } from 'react-router-dom'
import axios from 'axios'
import { useAuthContext } from '../../Hooks/useAuthContext'

/* ── Inline SVG icons (no extra dep) ───────────────────── */
const IconDashboard = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/>
    <rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>
  </svg>
)
const IconSend = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <line x1="22" y1="2" x2="11" y2="13"/>
    <polygon points="22 2 15 22 11 13 2 9 22 2"/>
  </svg>
)
const IconWithdraw = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <rect x="2" y="5" width="20" height="14" rx="2"/>
    <line x1="2" y1="10" x2="22" y2="10"/>
  </svg>
)
const IconExchange = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <polyline points="17 1 21 5 17 9"/>
    <path d="M3 11V9a4 4 0 0 1 4-4h14"/>
    <polyline points="7 23 3 19 7 15"/>
    <path d="M21 13v2a4 4 0 0 1-4 4H3"/>
  </svg>
)
const IconPayment = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <line x1="12" y1="1" x2="12" y2="23"/>
    <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
  </svg>
)
const IconDeposit = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
  </svg>
)
const IconLoan = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
)
const IconFD = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <rect x="2" y="3" width="20" height="14" rx="2"/>
    <line x1="8" y1="21" x2="16" y2="21"/>
    <line x1="12" y1="17" x2="12" y2="21"/>
  </svg>
)
const IconDPS = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <path d="M12 2a10 10 0 1 0 10 10"/>
    <path d="M12 6v6l4 2"/>
    <line x1="18" y1="2" x2="22" y2="6"/>
    <line x1="22" y1="2" x2="18" y2="6"/>
  </svg>
)
const IconTicket = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"/>
  </svg>
)
const IconReport = () => (
  <svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="1.9" viewBox="0 0 24 24">
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
    <polyline points="14 2 14 8 20 8"/>
    <line x1="16" y1="13" x2="8" y2="13"/>
    <line x1="16" y1="17" x2="8" y2="17"/>
    <polyline points="10 9 9 9 8 9"/>
  </svg>
)
const IconChevron = ({ open }) => (
  <svg
    width="12" height="12" fill="none" stroke="currentColor" strokeWidth="2.2"
    viewBox="0 0 24 24"
    style={{ marginLeft: 'auto', flexShrink: 0, transition: 'transform 240ms ease', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
  >
    <polyline points="6 9 12 15 18 9"/>
  </svg>
)

/* ── Nav structure ──────────────────────────────────────── */
const NAV = [
  {
    section: 'Overview',
    items: [
      { label: 'Dashboard',    icon: <IconDashboard />, to: '/dashboard' },
    ],
  },
  {
    section: 'Transactions',
    items: [
      { label: 'Send Money',    icon: <IconSend />,      to: '/transfer/send_money/' },
      { label: 'Withdraw',      icon: <IconWithdraw />,  to: '/automatic/withdraw/' },
      { label: 'Exchange Money',icon: <IconExchange />,  to: '/transfer/exchange_money/' },
    ],
  },
  {
    section: 'Requests & Deposits',
    items: [
      {
        label: 'Payment Request', icon: <IconPayment />, key: 'paymentRequest',
        children: [
          { label: 'New Request', to: '/payment_requests/create/' },
          { label: 'All Requests', to: '/payment_requests/' },
        ],
      },
      {
        label: 'Deposit Money', icon: <IconDeposit />, key: 'deposit',
        children: [
          { label: 'Automatic Deposit',  to: '/deposit/automatic_methods/' },
          { label: 'Manual Deposit',     to: '/deposit/manual_methods/' },
          { label: 'Redeem Gift Card',   to: '/deposit/redeem_gift_card/' },
        ],
      },
    ],
  },
  {
    section: 'Products',
    items: [
      {
        label: 'Loans', icon: <IconLoan />, key: 'loan',
        children: [
          { label: 'Apply New Loan', to: '/loans/apply_loan' },
          { label: 'My Loans',       to: '/loans/my_loans' },
        ],
      },
      {
        label: 'Fixed Deposit', icon: <IconFD />, key: 'fixedDeposit',
        children: [
          { label: 'Apply New FD', to: '/fixed_deposits/apply' },
          { label: 'FD History',   to: '/fixed_deposits/history' },
        ],
      },
      {
        label: 'DPS Scheme', icon: <IconDPS />, key: 'dps',
        children: [
          { label: 'DPS Plans', to: '/dps_schemes/plans' },
          { label: 'My DPS',    to: '/dps_schemes' },
        ],
      },
    ],
  },
  {
    section: 'Support',
    items: [
      { label: 'Support Tickets',     icon: <IconTicket />, to: '/tickets/create_ticket/' },
      { label: 'Transactions Report', icon: <IconReport />, to: '/transactions/history' },
    ],
  },
]

/* ════════════════════════════════════════════════════════
   SIDEBAR COMPONENT
════════════════════════════════════════════════════════ */
function Sidebar({ shouldMenuSlide, onClose = () => {} }) {
  const [open, setOpen]   = useState({})
  const [data, setData]   = useState(null)
  const { user }          = useAuthContext()
  const location          = useLocation()

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/user/get-user`, {
      headers: { Authorization: `Bearer ${user.token}` },
    }).then(r => setData(r.data)).catch(e => console.log(e.response))
  }, [user.token])

  const toggle = (key) => setOpen(p => ({ ...p, [key]: !p[key] }))

  const isActive = (to) =>
    to && (location.pathname === to || location.pathname.startsWith(to.replace(/\/$/, '')))

  const hasActiveChild = (children = []) =>
    children.some(c => isActive(c.to))

  return (
    <div
      className={shouldMenuSlide ? 'dashboard-menu slide-in-left' : 'dashboard-menu'}
      onClick={(e) => {
        /* Close when tapping the backdrop (the wrapper itself, not the sidebar panel) */
        if (e.target === e.currentTarget && onClose) onClose()
      }}
    >
      <div className="sidebar">

        {/* Close button — CSS hides it on desktop, shows on mobile */}
        <button className="sb-close-btn" onClick={onClose} aria-label="Close menu">
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" viewBox="0 0 24 24">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>

        {/* ── Profile header ──────────────────────────── */}
        <div className="sidebar-header">
          <div className="sb-avatar-wrap">
            <img
              src={
                data?.profile
                  ? `${process.env.REACT_APP_IMG_BACKEND_URL}images/${data.profile}`
                  : defaultProfile
              }
              alt="profile"
              className="profile-image"
            />
            <span className="sb-status-dot" />
          </div>
          <p className="profile-name">
            {data ? `${data.firstname} ${data.lastname}` : '—'}
          </p>
          {data?.accountNumber && (
            <p className="sb-account-no">#{data.accountNumber}</p>
          )}
        </div>

        {/* ── Navigation ──────────────────────────────── */}
        <nav className="sidebar-navigation">
          {NAV.map((group) => (
            <div className="sb-group" key={group.section}>
              <p className="sidebar-section-label">{group.section}</p>
              <ul>
                {group.items.map((item) => {
                  /* ── Simple link ─── */
                  if (!item.children) {
                    const active = isActive(item.to)
                    return (
                      <Link
                        key={item.label}
                        to={item.to}
                        className={`sb-link${active ? ' sb-link--active' : ''}`}
                      >
                        <li className={active ? 'sb-item--active' : ''}>
                          <span className="sb-icon">{item.icon}</span>
                          <p>{item.label}</p>
                          {active && <span className="sb-active-pip" />}
                        </li>
                      </Link>
                    )
                  }

                  /* ── Dropdown ─── */
                  const isOpen         = open[item.key]
                  const childActive    = hasActiveChild(item.children)
                  const expanded       = isOpen || childActive

                  return (
                    <li
                      key={item.label}
                      className={`nav-with-drop${childActive ? ' sb-item--active' : ''}`}
                    >
                      <div
                        className={`nav-item sb-drop-trigger${childActive ? ' sb-drop-trigger--active' : ''}`}
                        onClick={() => toggle(item.key)}
                      >
                        <span className="sb-icon">{item.icon}</span>
                        <p>{item.label}</p>
                        <IconChevron open={expanded} />
                      </div>

                      {expanded && (
                        <div className="sidebar-dropdown">
                          {item.children.map((child) => {
                            const ca = isActive(child.to)
                            return (
                              <Link key={child.label} to={child.to} className="sb-drop-link">
                                <span className={`sidebar-dropdown__item${ca ? ' sidebar-dropdown__item--active' : ''}`}>
                                  <span className="sb-drop-dot" />
                                  {child.label}
                                </span>
                              </Link>
                            )
                          })}
                        </div>
                      )}
                    </li>
                  )
                })}
              </ul>
            </div>
          ))}
        </nav>

      </div>
    </div>
  )
}

export default Sidebar